// extracted by mini-css-extract-plugin
export default {"printable":"Product_printable__s6Wxe","wrapper":"Product_wrapper__9y5Bh","container":"Product_container__g5nvM","volumes":"Product_volumes__UVZ1j"};